export default __webpack_public_path__ + "assets/images/icon-play-small.17fdaa6be7c032e6261d8505d1fd7adb.svg";